const isPlainObject = (value) =>
  value !== null && typeof value === 'object' && !Array.isArray(value);

export const sanitizeDeep = (value) => {
  if (value === undefined) return undefined;
  if (value === null) return null;
  if (Array.isArray(value)) {
    const sanitized = value
      .map((item) => sanitizeDeep(item))
      .filter((item) => item !== undefined);
    return sanitized;
  }
  if (isPlainObject(value)) {
    const result = {};
    Object.keys(value).forEach((key) => {
      const cleaned = sanitizeDeep(value[key]);
      if (cleaned !== undefined) {
        result[key] = cleaned;
      }
    });
    return result;
  }
  if (typeof value === 'function') return undefined;
  return value;
};
